/* eslint-disable array-callback-return */
import React, { Component } from "react";
import TableContent from "../../components/tableEventos";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import "./styles.scss";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
// import Push from '../../services/PushService';
import EventoService from "../../services/EventoService";
import Spinner from "react-spinner-material";

import Ufs from "../../assets/uf";

export default class Novidades extends Component {
  constructor() {
    super();
    this.state = {
      openModal: false,
      modalStyle: null,
      date: new Date(),
      mensagemError: "",

      title: "",
      descricao: "",
      listCidades: [],
      dataInicio: new Date(),
      dataFim: new Date(),
      horaInicio: new Date(),
      horaFim: new Date(),
      CEP: "",
      endereco: "",
      numero: "",
      complemento: "",
      estado: 0,
      cidade: "",
      latitude: "",
      longitude: "",
      mensagem: "",
      link: "",

      loading: true,
      loadingAdd: false,
      erroService: false,
      idEdit: null,

      filtrado: false,
      // FORMFILTER,
      formFiltertipo: "",
      formFiltermensagem: "",
      formFiltertitulo: "",
      formFilterVersaoIOS: "",
      formFilterVersaoANDROID: "",
      erroFiltro: "",
      imageUpload: null,
      imageBase64: null,
      tipoValue: "",
      tipoSelect: [
        { value: "VIDEO", label: "Vídeo" },
        { value: "IMAGEM", label: "Imagem" },
        { value: "DOCUMENTO", label: "Documento" },
      ],
    };
  }

  async componentDidMount() {
    this.GetEventos();
  }

  async GetEventos() {
    const content = await EventoService.listar();

    if (content.status === 200) {
      this.setState({ content, contentALL: content, loading: false });
    } else {
      // this.setState({ content, loading: false });
      this.setState({ erroService: true, loading: false });
    }
  }

  handleTipo = (e) => {
    const value = e.target.value;
    this.setState({ tipoValue: value });
  };

  openAdd = () => {
    this.setState({ openModal: true });
  };
  openFiltrar = () => {
    this.setState({ filtrar: !this.state.filtrar });
  };
  closeAdd = () => {
    this.resetForm();
  };

  resetForm() {
    this.setState({
      openModal: false,
      title: "",
      descricao: "",
      listCidades: [],
      dataInicio: new Date(),
      dataFim: new Date(),
      horaInicio: new Date(),
      horaFim: new Date(),
      CEP: "",
      endereco: "",
      numero: "",
      complemento: "",
      estado: "",
      cidade: "",
      latitude: "",
      longitude: "",
      mensagem: "",
      mensagemError: "",
      link: "",
      loadingAdd: false,
      idEdit: null,
    });
  }

  onChange = async (event) => {
    const image = event.target.files[0];
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    const file = await toBase64(image);
    if (image) {
      this.setState({
        imageUpload: file.replace(/^data:image\/[a-z]+;base64,/, ""),
        imageBase64: file.replace(/^data:image\/[a-z]+;base64,/, ""),
      });
    } else {
      this.setState({
        imageUpload: null,
      });
    }
  };

  resetFile = (event) => {
    event.preventDefault();
    this.setState({ imageUpload: null });
  };

  addItem = async () => {
    const {
      title,
      descricao,
      dataInicio,
      dataFim,
      horaInicio,
      horaFim,
      CEP,
      endereco,
      numero,
      complemento,
      estado,
      cidade,
      latitude,
      longitude,
      mensagem,
      idEdit,
      link,
    } = this.state;

    this.setState({ loadingAdd: true, mensagemError: "" });

    if (title === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Título é obrigatório",
      });
      return false;
    }

    if (descricao === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Descrição é obrigatório",
      });
      return false;
    }

    if (CEP === "") {
      this.setState({ loadingAdd: false, mensagemError: "CEP é obrigatório" });
      return false;
    }

    if (endereco === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Endereço é obrigatório",
      });
      return false;
    }

    if (numero === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Número é obrigatório",
      });
      return false;
    }

    if (complemento === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Complemento é obrigatório",
      });
      return false;
    }

    if (estado === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Estado é obrigatório",
      });
      return false;
    }

    if (cidade === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Cidade é obrigatório",
      });
      return false;
    }

    if (latitude === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Latitude é obrigatório",
      });
      return false;
    }

    if (longitude === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Longitude é obrigatório",
      });
      return false;
    }

    if (mensagem === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Mensagem é obrigatório",
      });
      return false;
    }

    const ufArray = Ufs.filter((e) => e.id === estado);

    let params = {
      id: idEdit ? idEdit : null,
      bairro: "",
      cep: CEP,
      cidade: cidade,
      complemento: complemento,
      coordenadas: {
        latitude: latitude,
        longitude: longitude,
      },
      dataFim: dataFim,
      dataInicio: dataInicio,
      descricao: descricao,
      endereco: endereco,
      horaFinal: horaFim,
      horaInicio: horaInicio,
      mensagem: mensagem,
      numero: numero,
      titulo: title,
      linkInscricao: link,
      uf: {
        id: ufArray[0].id
      }
    };

    if (!idEdit) {
      const res = await EventoService.salvar(params);
      if (res.status === 201) {
        this.closeAdd();
        this.setState({ loading: true });
        const content = await EventoService.listar();
        this.setState({ content, loading: false });
        this.resetForm();
      } else {
        this.setState({
          loadingAdd: false,
          mensagemError: "Erro ao cadastrar novidade, tente mais tarde!",
        });
      }
    } else {
      const res = await EventoService.atualizar(params);
      if (res.status === 200) {
        this.closeAdd();
        this.setState({ loading: true });
        const content = await EventoService.listar();
        this.setState({ content, loading: false });
        this.resetForm();
      } else {
        this.setState({
          loadingAdd: false,
          mensagemError: "Erro ao editar novidade, tente mais tarde!",
        });
      }
    }
  };

  SimpleModal() {
    const handleClose = () => {
      this.resetForm();
    };

    const handleEstado = async (event) => {
      this.setState({ estado: event.target.value });
    };

    makeStyles((theme) => ({
      paper: {
        position: "absolute",
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
      },
    }));

    const {
      title,
      descricao,
      link,
      dataInicio,
      dataFim,
      horaInicio,
      horaFim,
      CEP,
      endereco,
      numero,
      complemento,
      estado,
      cidade,
      latitude,
      longitude,
      mensagem,
    } = this.state;

    return (
      <Modal
        style={{ padding: 20 }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.openModal}
        onClose={handleClose}
        className="modal"
      >
        <Grid item xs={12} sm={8}>
          <button onClick={this.closeAdd} className="btnFechar">
            X
          </button>
          <div className="cardBox">
            <Grid container spacing={3} className="modal-header">
              <Grid item xs={12} sm={12}>
                <h2 id="simple-modal-title">Adicionar evento</h2>
              </Grid>
              <Grid item xs={12} sm={12}>
                <p id="simple-modal-description">
                  Preencha os campos para adicionar a seu evento.
                </p>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="title">Título</InputLabel>
                  <Input
                    autoComplete="off"
                    value={title}
                    onChange={(event) =>
                      this.setState({ title: event.target.value })
                    }
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug">
                    Digite o título
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="outlined-multiline-flexible"
                  label="Descrição"
                  multiline
                  rowsMax="4"
                  value={descricao}
                  onChange={(event) =>
                    this.setState({ descricao: event.target.value })
                  }
                  margin="normal"
                  helperText="Evento"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Selecione a data de início"
                    value={dataInicio}
                    onChange={(event) => this.setState({ dataInicio: event })}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Selecione a data de fim"
                    value={dataFim}
                    onChange={(event) => this.setState({ dataFim: event })}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    variant="inline"
                    format="HH:MM"
                    label="Selecione a hora de início"
                    value={horaInicio}
                    onChange={(event) => this.setState({ horaInicio: event })}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    variant="inline"
                    format="HH:MM"
                    label="Selecione a hora de fim"
                    value={horaFim}
                    onChange={(event) => this.setState({ horaFim: event })}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="title">Link do evento</InputLabel>
                  <Input
                    autoComplete="off"
                    value={link}
                    onChange={(event) =>
                      this.setState({ link: event.target.value })
                    }
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug">
                    Digite o título
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <div className="titleForm">
                <strong>ENDEREÇO</strong>
              </div>
              <Grid item xs={12} sm={3}>
                <FormControl>
                  <InputLabel htmlFor="title">CEP</InputLabel>
                  <Input
                    autoComplete="off"
                    value={CEP}
                    onChange={(event) =>
                      this.setState({ CEP: event.target.value })
                    }
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug"></FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl>
                  <InputLabel htmlFor="title">Endereço</InputLabel>
                  <Input
                    autoComplete="off"
                    value={endereco}
                    onChange={(event) =>
                      this.setState({ endereco: event.target.value })
                    }
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug"></FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl>
                  <InputLabel htmlFor="title">Número</InputLabel>
                  <Input
                    autoComplete="off"
                    value={numero}
                    onChange={(event) =>
                      this.setState({ numero: event.target.value })
                    }
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug"></FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl>
                  <InputLabel htmlFor="title">Complemento</InputLabel>
                  <Input
                    autoComplete="off"
                    value={complemento}
                    onChange={(event) =>
                      this.setState({ complemento: event.target.value })
                    }
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug"></FormHelperText>
                </FormControl>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3}>
                  <FormControl>
                    <InputLabel htmlFor="age-simple">Estado</InputLabel>
                    <Select
                      value={estado}
                      defaultValue={estado}
                      onChange={handleEstado}
                      displayEmpty={false}
                      inputProps={{
                        name: "age",
                        id: "age-simple",
                      }}
                    >
                      {Ufs.map((option, index) => (
                        <MenuItem key={index} value={option.id}>
                          {option.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl>
                    <InputLabel htmlFor="title">Cidade</InputLabel>
                    <Input
                      autoComplete="off"
                      value={cidade}
                      onChange={(event) =>
                        this.setState({ cidade: event.target.value })
                      }
                      id="title"
                      aria-describedby="title-slug"
                    />
                    <FormHelperText id="title-slug"></FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={12}>
                <div className="titleForm">
                  <strong>GEOLOCALIZAÇÃO</strong>
                </div>
                <Grid item xs={12} sm={3}>
                  <FormControl>
                    <InputLabel htmlFor="title">Latitude</InputLabel>
                    <Input
                      autoComplete="off"
                      value={latitude}
                      onChange={(event) =>
                        this.setState({ latitude: event.target.value })
                      }
                      id="title"
                      aria-describedby="title-slug"
                    />
                    <FormHelperText id="title-slug">
                      Digite o título
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl>
                    <InputLabel htmlFor="title">Longitude</InputLabel>
                    <Input
                      autoComplete="off"
                      value={longitude}
                      onChange={(event) =>
                        this.setState({ longitude: event.target.value })
                      }
                      id="title"
                      aria-describedby="title-slug"
                    />
                    <FormHelperText id="title-slug">
                      Digite o título
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Mensagem"
                    multiline
                    rowsMax="4"
                    value={mensagem}
                    onChange={(event) =>
                      this.setState({ mensagem: event.target.value })
                    }
                    margin="normal"
                    helperText="Digite a descrição"
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              <button className="btnAdd" onClick={this.addItem}>
                {this.state.idEdit ? "Salvar" : "Adicionar"}
              </button>
              <Spinner
                size={30}
                spinnerColor={"#0061c6"}
                spinnerWidth={4}
                visible={this.state.loadingAdd ? true : false}
              />
              <div className={"mensagemError"}>{this.state.mensagemError}</div>
            </Grid>
          </div>
        </Grid>
      </Modal>
    );
  }

  getFilter = async () => {
    const {
      contentALL,
      formFiltertipo,
      formFiltertitulo,
      formFilterVersaoIOS,
    } = this.state;

    this.setState({ filtrar: false, loading: true });
    setTimeout(() => {
      const dataTemp = {};

      if (
        formFilterVersaoIOS !== "" &&
        formFiltertitulo !== "" &&
        formFiltertipo !== ""
      ) {
        dataTemp.data = contentALL.data.filter(
          (e) =>
            e.titulo.indexOf(formFiltertitulo) > -1 &&
            e.versaoIOS === formFilterVersaoIOS &&
            e.typeTipo === formFiltertipo
        );
      } else if (formFilterVersaoIOS !== "") {
        dataTemp.data = contentALL.data.filter(
          (e) =>
            e.titulo.indexOf(formFiltertitulo) > -1 &&
            e.versaoIOS === formFilterVersaoIOS
        );
      } else {
        dataTemp.data = contentALL.data.filter(
          (e) => e.titulo.indexOf(formFiltertitulo) > -1
        );
      }

      this.setState({ content: dataTemp, loading: false });
    }, 1);
  };

  limparFiltro = () => {
    this.setState({
      formFiltercnae: "",
      formFiltermensagem: "",
      formFiltertitulo: "",
      formFilteruf: "",
      loading: true,
      filtrado: false,
    });
    this.GetEventos();
  };

  async listenCard(value, key) {
    const { content } = this.state;
    const values = content.data[key];
    let changes = {
      descricao: values.descricao,
      title: values.titulo,
      dataInicio: new Date(values.dataInicio),
      dataFim: new Date(values.dataFim),
      horaInicio: new Date(values.horaInicio),
      horaFim: new Date(values.horaFinal),
      CEP: values.cep,
      endereco: values.endereco,
      numero: values.numero,
      complemento: values.complemento,
      latitude: values.coordenadas.latitude,
      longitude: values.coordenadas.longitude,
      mensagem: values.mensagem,
      idEdit: values.id,
      link: values.linkInscricao,
      openModal: true,
    };

    changes.estado = values.uf.id;
    changes.cidade = values.cidade;
    this.setState(changes);
  }

  render() {
    const {
      loading,
      erroService,
      content,
      erroFiltro,
      tipoSelect,
      formFiltertipo,
      formFiltermensagem,
    } = this.state;
    if (loading) {
      return <div>Carregando...</div>;
    }
    if (erroService) {
      return (
        <>
          <div>Erro de servidor, tente mais tarde!.</div>
        </>
      );
    }
    return (
      <div style={{ padding: 20 }}>
        <Grid container direction="row" justify="space-between">
          {/* <div>
                        <button className='btnAdd' onClick={() => this.openFiltrar()}>Filtrar</button>
                        {filtrado && (
                            <button className='btnAdd btnLimpar' onClick={() => this.limparFiltro()}>Limpar filtro</button>
                        )}
                    </div> */}
          <button className="btnAdd" onClick={() => this.openAdd()}>
            Adicionar
          </button>
        </Grid>

        {this.state.filtrar && (
          <Grid container direction="row">
            <div className="cardBox formSearch">
              <Grid container spacing={3} className="modal-header">
                <Grid item xs={12} sm={12}>
                  <h2 id="simple-modal-title">Filtrar</h2>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormControl>
                    <InputLabel htmlFor="title">Título</InputLabel>
                    <Input
                      autoComplete="off"
                      value={this.state.formFiltertitulo}
                      onChange={(value) => {
                        this.setState({ formFiltertitulo: value.target.value });
                      }}
                      id="title"
                      aria-describedby="title-slug"
                    />
                    <FormHelperText id="title-slug">
                      Digite o título
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl>
                    <InputLabel htmlFor="title">Versão IOS</InputLabel>
                    <Input
                      autoComplete="off"
                      value={this.state.formFilterVersaoIOS}
                      onChange={(value) => {
                        this.setState({
                          formFilterVersaoIOS: value.target.value,
                        });
                      }}
                      id="title"
                      aria-describedby="title-slug"
                    />
                    <FormHelperText id="title-slug">Versão</FormHelperText>
                  </FormControl>
                  <br></br>
                  <FormControl>
                    <InputLabel htmlFor="title">Versão ANDROID</InputLabel>
                    <Input
                      autoComplete="off"
                      value={this.state.formFilterVersaoANDROID}
                      onChange={(value) => {
                        this.setState({
                          formFilterVersaoANDROID: value.target.value,
                        });
                      }}
                      id="title"
                      aria-describedby="title-slug"
                    />
                    <FormHelperText id="title-slug">Versão</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={6} sm={6}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Mensagem"
                    multiline
                    rowsMax="4"
                    value={formFiltermensagem}
                    onChange={(value) => {
                      this.setState({ formFiltermensagem: value.target.value });
                    }}
                    margin="normal"
                    helperText="Digite a mensagem"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <FormControl>
                    <InputLabel htmlFor="age-simple">Tipo</InputLabel>
                    <Select
                      value={formFiltertipo}
                      onChange={(value) => {
                        this.setState({ formFiltertipo: value.target.value });
                      }}
                      inputProps={{
                        name: "age",
                        id: "age-simple",
                      }}
                    >
                      {tipoSelect.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <button className="btnAdd" onClick={this.getFilter}>
                Filtrar
              </button>
              <Spinner
                size={30}
                spinnerColor={"#0061c6"}
                spinnerWidth={4}
                visible={this.state.loadingAdd ? true : false}
              />
            </div>
          </Grid>
        )}
        {erroFiltro && (
          <div style={{ color: "red" }}>
            Erro ao efetuar filtro, tente novamente! <br />
            <br />
          </div>
        )}
        <TableContent
          editItem={(value, key) => this.listenCard(value, key)}
          content={content.data}
          rowsTable={[]}
        />

        {this.SimpleModal()}
      </div>
    );
  }
}
